import CustomSelectList from './CustomSelectList'

export default function CustomSelectListInput({ label, handleChange, name, multiple, modelName, entityName, defaultValue, allOption, allOptionSelected, blankOption, uniqueOptionCallback, dataCy }) {
  console.log(`CustomSelectListInput rendered: ${label}`)

  return (
    <tr>
      <td><b>{label}</b></td>
      <td>
        <CustomSelectList
          className="custom-input" 
          handleChange={handleChange}
          name={name}
          multiple={multiple}
          modelName={modelName}
          entityName={entityName}
          defaultValue={defaultValue}
          allOption={allOption}
          allOptionSelected={allOptionSelected}
          blankOption={blankOption}
          uniqueOptionCallback={uniqueOptionCallback}
          dataCy={dataCy}
        />
      </td>
    </tr>
  )
}
